(function()
{
  $(document).ready(function () {

    $("body").on('click', '.jc-bs3-container .jc-bs3-row .jconfirm-box-container .jconfirm-buttons .btn.btn-default:nth-child(1)', function()
    {
      if($(".jc-bs3-container .jc-bs3-row .jconfirm-box-container .jconfirm-buttons .btn.btn-default:nth-child(1)").html() == "Keep Shopping" && window.location.href.indexOf('cart') > -1)
      {
        window.location.href = window.location.href
      }
    });
    $(document).on('swell:initialized', function ()
    {
      if(".swell-redeem-points-list".length>0) {
        SwellConfig.PointsRedemption.AppendRedemptions();
     }
    });
    
    $(document).on("swell:setup", function() {
      Swell.Campaign.initializeCampaigns(".swell-campaign-list", SwellConfig.Campaign.opts);
      Swell.Referral.initializeReferral(".swell-referral", SwellConfig.Referral.opts);
      SwellConfig.Referral.authenticated();
      SwellConfig.Referral.populateReferrals();
      Swell.Redemption.initializeProductRedemptions(".swell-redemption-list", SwellConfig.ProductRedemption.opts);
      if(spapi.authenticated && spapi.customer.vip_tier)
      {
        $(".redemptions-for-vip").css("display","flex");
      }
      checkCountProductRedemption();
      if($(".swell-redemption-list").length > 0)
      {
        addSlickToProductRedemption();
      }
      if (spapi.authenticated) {
        swellAPI.refreshEmbeds();
      }
      SwellConfig.Tier.initializeDummyTier();
      SwellConfig.Tier.initializeCustomTierProperties();
      SwellConfig.Tier.initializeTiers(".swell-tier-table");
      $(".loader-custom-load-holder").remove();
      if($(".post-checkout-popup").length > 0)
      {
        $(".post-checkout-popup").css("display","flex");
      }
    });
      
    var next_tier = 2;
    reset();
    $(window).resize(function()
    {
      next_tier = 2;
      reset();
    });

    $('body').on('click','.table_arrow_right',function(e)
    {
      var tdclass = ".td";
      var tohide = tdclass + next_tier;
      if(next_tier < 4)
      {
        next_tier++;
        var nextToGo = tdclass + next_tier;
        $(tohide).css('display','none');
        $(nextToGo).css('display','table-cell');
        if(next_tier == 4)
        {
          $('.table_arrow_right').css('opacity','0.5');
        }
        else
        {
          $('.table_arrow_left').css('opacity','1');
        }
      }
      else
      {
        e.preventDefault();
      }
    });

    $('body').on('click','.table_arrow_left',function(e)
    {
      var tdclass = ".td";
      var tohide = tdclass + next_tier;
      if(next_tier > 2)
      {
        next_tier--;
        var previousToGo = tdclass + next_tier;
        $(tohide).css('display','none');
        $(previousToGo).css('display','table-cell');
        if(next_tier == 2)
        {
          $('.table_arrow_left').css('opacity','0.5');
        }
        else
        {
          $('.table_arrow_right').css('opacity','1');
        }
      }
      else
      {
        e.preventDefault();
      }
    });

    $('body').on('click', '.swell-referral-copy', function(e) {
      if ($(e.target).hasClass("swell-referral-copy")) {
          e.stopPropagation();
      }
    });

    $('body').on('click','.close-postcheckout-popup', function()
    {
      $('.post-checkout-popup').remove();
    });

    $('body').on('click','.swell-share-referral-copy', function()
    {
      $('.swell-referral').hide();
      if($('.redeem-holder').length > 0)
      {
        $('.redeem-holder').hide();
      }
      setTimeout(function () {
        var pop_up = $(".swell-referral-copy").detach();
        if($(".post-checkout-popup").length > 0)
        {
          $(".post-checkout-content").append(pop_up);
        }
        else
        {
          $(".swell-referral-main-content").append(pop_up);
        }
      }, 20);
      setTimeout(function () {  
        if($(window).width() < 748 )
        {
          $('.post-checkout-main').scrollTop($('.post-checkout-main')[0].scrollHeight);
        }
      }, 20);
    });

    $('body').on('click','.swell-referral-copy .swell-referral-copy-content .swell-referral-copy-main .swell-referral-back-link', function()
    {
      var pop_up = $(".swell-referral-copy").remove();
      if($('.redeem-holder').length > 0)
      {
        $('.redeem-holder').show();
      }
      $('.swell-referral').show();
    });

    $(document).on("swell:referral:success", function() {
      swellAPI.refreshCustomerDetails(function() {
        $(".table-data").html("");
        SwellConfig.Referral.populateReferrals();
      });
    });

    $(document).on("swell:referral:error", function(jqXHR, textStatus, errorThrown) {
      if(textStatus && textStatus === "EMAILS_ALREADY_PURCHASED") {
        $(".refer-customer-error").remove();
        $(".swell-referral-form-list").before('<p class="refer-customer-error">Sorry! Looks like this person has already made a purchase. Try referring another friend.</p>');
      }

      if(textStatus && textStatus === "Please enter a valid email address") {
        $(".refer-customer-error").remove();
        $(".swell-referral-form-list").before('<p class="refer-customer-error">Please enter valid email addresses seperated with commas</p>');
      }
    });

  });
}).call(this);

//refer
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Referral = {
    opts: {
      localization: {
        referralSidebarDetailsAction: "Refer a Friend",
        referralSidebarDetailsReward: "<%= referralCampaign.reward_text %>",

        referralRegisterHeading: "Give $20, Get $20",
        referralRegisterFormDetails: "Enter your email to get started.",
        referralRegisterFormEmail: "Enter your email to get started",
        referralRegisterFormSubmit: "NEXT >",
        // referralRegisterDetails: "Get 20 points for every friend who successfully signs up for The Rewards. Your friend will receive $20 off their first purchase of $50 or more.",
        referralRegisterDetails: "Give your friends $20 off their first purchase of $50+ and get $20 in points for each successful referral.",

        referralReferHeading:"Give $20, Get $20",
        referralReferFormEmails: "Enter Your friends’ emails (seperated by commas)",
        referralReferFormSubmit: "SEND",
        referralReferFormDetails: "Please submit your friend's email below to get started.",
        referralReferFormEmailsDetails: "",
        referralReferDetails: "Give your friends $20 off their first purchase of $50+ and get $20 in points for each successful referral.",

        referralReferMediaDetails: "Share On Social",

        referralShareFacebook: "Share",
        referralShareTwitter: "Tweet",
        referralShareCopy: "Copy Link",
        referralShareMessenger: "Message",
        referralShareSMS: "SMS",

        referralFacebookIcon: "swell-icon-facebook-share",
        referralTwitterIcon: "swell-icon-twitter",
        referralLinkIcon: "swell-icon-copy-link",
        referralMessengerIcon: "swell-icon-messenger",
        referralSMSIcon: "swell-icon-sms",

        referralThanksHeading: "Thanks for Referring!",
        referralThanksDetails: "Remind your friends to check their emails.",

        referralCopyHeading: "",
        referralCopyButton: "COPY LINK",
        referralCopyDetails: "Copy link and share with your friends."
      },
      templates: {
        referralRegister: '<div class="swell-referral-register"> <h2 class="swell-referral-heading"><%= localization.referralRegisterHeading %></h2> <p class="swell-referral-details"><%= localization.referralRegisterDetails %></p> <div class="swell-border"></div> <div class="swell-referral-form-wrapper"> <form name="swell-referral-register-form" id="swell-referral-register-form" method="POST" action="."> <div class="swell-referral-form-header"> <p class="swell-referral-form-header-details register-details-only"><%= localization.referralRegisterFormDetails %></p> </div> <div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="email" name="swell-referral-register-email" id="swell-referral-register-email" required="required" placeholder="<%= localization.referralRegisterFormEmail %>"> </li> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-submit" type="submit" name="swell-referral-register-submit" id="swell-referral-register-submit" value="<%= localization.referralRegisterFormSubmit %>"> </li> </ul> </div> </form> </div> </div>',
        referralRefer: '<div class="swell-referral-refer"> <h2 class="swell-referral-heading"><%= localization.referralReferHeading %></h2> <p class="swell-referral-details"><%= localization.referralReferDetails %></p> <div class="swell-border"></div> <div class="swell-referral-form-wrapper"> <form class="swell-referral-form" name="swell-referral-refer-form" id="swell-referral-refer-form" method="POST" action="."> <div class="swell-referral-form-header"> <p class="swell-referral-form-header-details"><%= localization.referralReferFormDetails %></p> </div> <div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="text" name="swell-referral-refer-emails" id="swell-referral-refer-emails" required="required" placeholder="<%= localization.referralReferFormEmails %>"> </li> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-submit" type="submit" name="swell-referral-refer-submit" id="swell-referral-refer-submit" value="<%= localization.referralReferFormSubmit %>"> </li> </ul> </div> </form> </div> <div class="swell-referral-media-wrapper"> <p class="swell-referral-media-details"><%= localization.referralReferMediaDetails %></p> <ul class="swell-referral-media-list"> <li class="swell-referral-medium swell-share-referral-facebook"> <div class="swell-referral-medium-content"> <i class=" <%= localization.referralFacebookIcon %>" aria-hidden="true"></i> <div><%= localization.referralShareFacebook %></div> </div> </li> <li class="swell-referral-medium swell-share-referral-twitter"> <div class="swell-referral-medium-content"> <i class="<%= localization.referralTwitterIcon %>" aria-hidden="true"></i> <div><%= localization.referralShareTwitter %></div> </div> </li> <li class="swell-referral-medium swell-share-referral-messenger"> <div class="swell-referral-medium-content"> <i class="<%= localization.referralMessengerIcon %>" aria-hidden="true"></i> <div><%= localization.referralShareMessenger %></div> </div> </li> <li class="swell-referral-medium swell-share-referral-copy"> <div class="swell-referral-medium-content"> <i class="<%= localization.referralLinkIcon %>" aria-hidden="true"></i> <div><%= localization.referralShareCopy %></div> </div> </li> </ul> </div> </div>',
        referralCopy: '<div class="swell-referral-copy"> <div class="swell-referral-copy-content"> <div class="swell-referral-copy-sidebar"></div> <div class="swell-referral-copy-main"> <span class="swell-referral-back-link"></span> <h2 class="swell-referral-heading"> <i class="swell-referral-heading-icon swell-icon-copy-link" aria-hidden="true"></i>&nbsp; </h2> <div class="swell-referral-form-wrapper"> <div class="swell-referral-copy-link" id="swell-referral-copy-link"><%= customer.referralLink %></div> <button class="swell-referral-copy-button" id="swell-referral-copy-button" data-clipboard-target="#swell-referral-copy-link">COPY LINK</button> <p class="swell-referral-details">Copy and share with friends.</p> </div> </div> </div> <div> </div></div>'
      }
    }, 
    authenticated: function () {
      if(spapi.authenticated)
      {
        if($(".redeem-holder").length > 0)
        {
          $(".redeem-holder").css('display','block');          
        }
      }
    },
    populateReferrals: function(){
      if (spapi.authenticated) {
        var referral_receipts = spapi.customer.referral_receipts;
        referral_receipts.forEach(function(referral_receipt) {
          var email = referral_receipt.email;
          var completed_at = referral_receipt.completed_at;
          if (completed_at) {
            status = "Purchased (" + spapi.activeReferralCampaign.reward_text + "earned)";
          } else {
            status = 'invited';
          }
          $(".table-data").append("<tr class='swell-table-row'><td class='swell-td'><div class='swell-truncate'>" + email + "</div></td><td class='swell-td'>" + status + "</td></tr>");
        });
      }
    }
  };
}).call(this);

// campaigns
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Campaign = {
    opts: {
      templates: {
        campaign: "<li class='swell-campaign'> <div class='swell-campaign-link swell-campaign-content' data-display-mode='modal' data-campaign-id='<%= campaign.id %>'> <div class='swell-campaign-icon'> <span class='swell-campaign-icon-content'><i class='<%= campaign.icon %>'></i></span> </div> <div class='swell-campaign-type'> <span class='swell-campaign-type-content'><%= campaign.title %></span> </div> <div class='swell-campaign-value'> <span class='swell-campaign-value-content'><%= campaign.reward_text %></span> </div> </div> </li>"
      }
    }
  };
}).call(this);

(function ()
{
  window.SwellConfig = window.SwellConfig || {};
  SwellConfig.PointsRedemption = {
    AppendRedemptions: function()
    {
      var redemptions = spapi.activeRedemptionOptions;
      redemptions.forEach(function (redemption)
      {
        if (redemption.discount_type == "percentage")
        {
          $('.swell-redeem-points-list').append('<li class="swell-redeem-points"> <div class="swell-redeem-points-content swell-redemption-link" data-redemption-option-id=' + redemption.id + '> <div class="swell-redeem-points-type">' + redemption.name + '</div> <div class="swell-redeem-points-value">' + redemption.cost_text + '</div> </div> </li>');
        }
      }); 
    }
  }
}).call(this);

//tiers
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Tier = {
    getCustomerTierId: function() {
      var customer_tier, intro_tier, tiers;
      customer_tier = spapi.customer.vip_tier;
      tiers = spapi.activeVipTiers;
      if (customer_tier) {
        return customer_tier.id;
      } else {
        intro_tier = $.grep(tiers, function(e) {
          return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
        });
        if (intro_tier.length > 0) {
          return intro_tier[0].id;
        } else {
          return null;
        }
      }
    },
    getCustomerTierRank: function() {
      var customer_tier, intro_tier, rank, tiers;
      customer_tier = spapi.customer.vip_tier;
      tiers = spapi.activeVipTiers;
      if (customer_tier && customer_tier.id) {
        rank = $.grep(tiers, function(e) {
          return e.id === customer_tier.id;
        })[0].rank;
        return rank;
      } else {
        intro_tier = $.grep(tiers, function(e) {
          return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
        });
        if (intro_tier.length > 0) {
          return intro_tier[0].rank;
        } else {
          return null;
        }
      }
    },
    getTierByRank: function(rank) {
      var tiers;
      tiers = spapi.activeVipTiers;
      return $.grep(tiers, function(e) {
        return e.rank === rank;
      })[0];
    },
    setupCustomerTierStatus: function() {
      var $tierStatusRow, $tierValueRow, col, columnLength, customer_tier_id, customer_tier_rank, data_id, dollar_difference, encouragement, index, k, l, next_tier, ref, ref1, next_tier_ammount;
      customer_tier_id = SwellConfig.Tier.getCustomerTierId();
      customer_tier_rank = SwellConfig.Tier.getCustomerTierRank();
      if(customer_tier_id === null)
      {
        customer_tier_id = -1;
      }
      if(customer_tier_rank === null)
      {
        customer_tier_rank = 0;
      }
      next_tier = SwellConfig.Tier.getTierByRank(customer_tier_rank + 1);
      
      $(".swell-tier-table").addClass("swell-tier-status");
      $(".swell-tier-table thead").prepend("<tr class=\"swell-tier-status-row\">\n  <th scope=\"row\"></th>\n</tr>");
      $("[data-tier-id=\"" + customer_tier_id + "\"]").addClass("swell-tier-active");
      columnLength = $(".swell-tier-table tbody tr:eq(0)").children().length;
      $tierStatusRow = $(".swell-tier-status-row");
      $tierValueRow = $(".swell-tier-values");
      encouragement = "";
      dollar_difference = "";
      for (col = k = 1, ref = columnLength - 1; 1 <= ref ? k <= ref : k >= ref; col = 1 <= ref ? ++k : --k) {
        data_id = $(".swell-tier-table tbody tr:first td:eq(" + (col - 1) + ")").first().data("tierId");
        if (data_id === customer_tier_id) {
          for (index = l = 1, ref1 = col; 1 <= ref1 ? l <= ref1 : l >= ref1; index = 1 <= ref1 ? ++l : --l) {
            $tierValueRow.find("th:eq(" + index + ")").addClass("completed");
          }
        }
        if(next_tier)
        {
          next_tier_ammount = (next_tier.points_earned - swellAPI.getCustomerDetails().vipTierStats.pointsEarned);
        }
        if(spapi.customer)
        {
          if (customer_tier_id === spapi.activeVipTiers[spapi.activeVipTiers.length - 1].id) {
            encouragement = "<div class='current-encourage'><div>Current Status</div><p>You are in the top tier</p></div>";
          } 
          else 
          {
            if(next_tier_ammount > 0)
            {
              encouragement = "<div class='current-encourage'><div>Current Status</div><p>"+next_tier_ammount+" Points more to earn "+next_tier.name+"</p></div>";
            }
            else
            {
              encouragement = "<div class='current-encourage'><div>Current Status</div><p>"+0+" Points more to earn "+next_tier.name+"</p></div>";
            }
          }
        }
      }
      var append_td_i;
      var tdclassno=2;
      var tdclass="td";
      var tdclass_append = tdclass + tdclassno;
      for ( append_td_i = customer_tier_rank; append_td_i > 0; append_td_i-- )
      {
        tdclass_append = tdclass + tdclassno;
        $tierStatusRow.append("<th scope='col' class='"+ tdclass_append +"'></th>");
        tdclassno++;
      }
      tdclass_append = tdclass + tdclassno;
      return $tierStatusRow.append("<th scope=\"col\" class='"+ tdclass_append +"'>" + encouragement + "</th>");
    },
    initializeDummyTier: function() {
      var k, len, tier, tiers;
      tiers = spapi.activeVipTiers;
      for (k = 0, len = tiers.length; k < len; k++) {
        tier = tiers[k];
        tier.rank += 1;
      }
      return tiers.unshift({
        id: -1,
        rank: 0,
        name: "Chrome",
        tiercopy:"<span class='once'>Just for signing up.</span>",
        one_point_multiplier: 'Every $1 Spent = 1 Point',
        shipping: "",
        early_access: "<div class='circle'></div>",
        early_access_sales: "<div class='circle'></div>",
        swellrequiredAmountSpentCents: 0,
        swellrequiredPointsEarned: 0,
        swellrequiredPurchasesMade: 0,
        swellrequiredReferralsCompleted: 0
      });
    },
    initializeCustomTierProperties: function() {
      spapi.activeVipTiers[1].tiercopy = "<span class='once'>Once you've reached "+spapi.activeVipTiers[1].points_earned+" points.*</span>";
      spapi.activeVipTiers[1].one_point_multiplier = "Every $1 Spent = 1.5 Points";
      spapi.activeVipTiers[1].shipping = "";
      spapi.activeVipTiers[1].early_access = "<div class='circle'></div>";
      spapi.activeVipTiers[1].early_access_sales = "<div class='circle'></div>";

      spapi.activeVipTiers[2].tiercopy = "<span class='once'>Once you've reached "+spapi.activeVipTiers[2].points_earned+" points.*</span>";
      spapi.activeVipTiers[2].one_point_multiplier = "Every $1 Spent = 2 Points";
      spapi.activeVipTiers[2].shipping = "<div class='circle'></div>";
      spapi.activeVipTiers[2].early_access = "<div class='circle'></div>";
      spapi.activeVipTiers[2].early_access_sales = "<div class='circle'></div>";
    },
    initializeTiers: function(containerSelector) {
      var i, j, key, properties, property, ref, ref1, tiers;
      if ($(containerSelector).length === 0) {
        return "";
      }
      tiers = spapi.activeVipTiers;
      properties = {
        header: {
          
          name: {
            className: "swell-tier-names",
            title: "Benefits"
          }
        },
        body: {
          one_point_multiplier: {
            title: "Point Multiplier"
          },
          shipping: {
            title: "Free 2-day Shipping"
          },
          early_access: {
            title: "Early access to new product launches"
          },
          early_access_sales: {
            title: "Complimentary samples"
          },
        }
      };
      $(containerSelector).append("<thead></thead>");
      $(containerSelector).append("<tbody></tbody>");
      j = 0;
      ref = properties.header;
      var tier_points = "points";
      for (key in ref) {
        var tdclassno=1;
        var tdclass="td";
        var tdclass_append=null;
        property = ref[key];
        $(containerSelector).find("thead").append("<tr class=\"" + property.className + "\">\n  <th scope=\"row\">" + property.title + "</th>\n</tr>");
        tiers.forEach(function(tier) {
          tdclassno++;
          tdclass_append = tdclass + tdclassno;
          return $(containerSelector).find("thead tr:eq(" + j + ")").append("<th scope=\"col\" data-tier-id=\"" + tier.id + "\" class=\"" +tdclass_append+ "\">" + tier[key]+ "<br>" + tier.tiercopy+"</th>");
        });
        j++;
      }
      i = 0;
      ref1 = properties.body;
      for (key in ref1) {
        var tdclassno=1;
        var tdclass="td";
        var tdclass_append=null;
        property = ref1[key];
        $(containerSelector).find("tbody").append("<tr>\n  <td scope=\"row\">" + property.title + "</td>\n</tr>");
        tiers.forEach(function(tier) {
          tdclassno++;
          tdclass_append = tdclass + tdclassno;
          return $(containerSelector).find("tbody tr:eq(" + i + ")").append("<td data-tier-id=\"" + tier.id + "\" class=\"" +tdclass_append+ "\" >" + tier[key] + "</td>");
        });
        i++;
        reset();
      }
      if (spapi.authenticated) {
        return SwellConfig.Tier.setupCustomerTierStatus();
      }
    }
  };
}).call(this);

// Product redemption
(function () {
  window.SwellConfig = window.SwellConfig || {};
  SwellConfig.ProductRedemption = {
    opts: {
      templates: {
        redemptionOptionProduct: '<div class="redemption"> <div class="swell-redemption-option-content swell-buy-product-btn" data-error-content="Looks like you don\'t have enough points for this product.  This product costs *|amount|* points and you only have *|point_balance|* points available." coupon_id="<%= redemption.id %>" data-confirm-btn-text="Add it" data-variant-id="<%= redemption.applies_to_id %>"> <div class="product-image"> <img src="<%= redemption.background_image_url %>" class="swell-image-one"> </div> <p><%= redemption.name %></p> <div class="swell-product-points"><%= redemption.cost_text %></div> </div> </div>'
      },
    }
  };  
}).call(this);

function checkCountProductRedemption()
{
  if($(".swell-redemption-list .redemption .swell-redemption-option-content").length % 2 == 1 )
  {
    $(".swell-redemption-list .redemption:last-child").addClass("last-child-in-oddCase");
  }
}

//add slick to redemptions
function addSlickToProductRedemption()
{
  $('.swell-redemption-list').slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 2,
    arrows: true,
    nextArrow: '<div class="arrow-area arrow-right"><i class="swell-icon-arrow-right"></i></div>',
    prevArrow: '<div class="arrow-area arrow-left"><i class="swell-icon-arrow-left"></i></div>',
  });
}

function reset()
{
 $('.table_arrow_left').css('opacity','0.5');
 check_window();
}

function check_window()
{
 if($(window).width() < 748 )
 {
   $(".td2").css("display","table-cell");
   $(".td3").css("display","none");
   $(".td4").css("display","none");
 }
 else
 {
   $(".td2").css("display","table-cell");
   $(".td3").css("display","table-cell");
   $(".td4").css("display","table-cell");
 }
}

window.onBeforeProductRedemption = function(opts, redemptionOption, pointBalance, cb){
  var redeemedItemsInCart = 0;
  var regularItemsInCart = 0;
  var already_product = 0;
  var content;
  var productURL = "/products/"+redemptionOption.icon+".js";
  var CartItems;
  $.ajax({
   url: productURL,
   type: "Get",
   dataType: 'json',
   success: function(s) {
      s.variants.forEach(function(variant)
      {
        if(variant.id == redemptionOption.applies_to_id)
        {
          if(variant.available)
          {
            $.ajax({
              type: 'GET', 
              url: '/cart.js',
              dataType: 'json',
              success: function(cart){
                CartItems = cart;
                if(CartItems && CartItems.items)
                {
                  var cart = CartItems.items;
                  cart.forEach(function(item)
                  {
                    if(item.properties._swell_points_used)
                    {
                      redeemedItemsInCart++;
                    } 
                    else if(item.line_price > 0)
                    {
                      regularItemsInCart++; 
                    }
                  });
                  if(regularItemsInCart == 0 || redeemedItemsInCart >= 2)
                  {
                    if(regularItemsInCart == 0)
                    {
                      content = "Your cart cannot be empty in order to redeem awards"
                    }
                    else if(redeemedItemsInCart >= 2)
                    {
                      content = "You already have two awards items in your cart"
                    }
                    spapi.$.confirm({
                      title: "Oops!",
                      content: content,
                      type: "red",
                      typeAnimated: true,
                      useBootstrap: false,
                      boxWidth: "400px",
                      buttons: {
                        ok: {
                          text: "Ok",
                          action: function () {
                          }
                        }
                      }
                    });
                  }
                  else {
                    cb();   
                  }
                }
              } 
            });
          }
          else
          {
            spapi.$.confirm({
              title: "Oops!",
              content: "We're sorry, this is out of stock",
              type: "red",
              typeAnimated: true,
              useBootstrap: false,
              boxWidth: "400px",
              buttons: {
                ok: {
                  text: "Ok",
                  action: function () {
                  }
                }
              }
            });
          }
        }
      });
    },
  });
};
